import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import ActionButtons from '../components/Common/ActionButtons';
import Footer from '../components/Common/Footer';
import Header from '../components/Common/Header/Header';
import Navigator from '../components/Common/Navigator';

const Layout = props => {
    //Tomo los props
    const { title, subtitle, actions, items } = props;
    //Render
    return (
        <React.Fragment>
            <Header />
            <Container fluid className="pb-5">
                <Row className="pb-5">
                    <Col className="main-content">
                        <main className="col-md-12 px-2">
                            <Navigator
                                items={items}
                            />

                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                                <h2 className="h2">
                                    { title }
                                    {
                                        subtitle ? (
                                            <>
                                            <br className="d-md-none" />
                                            <small className="text-muted ml-md-2">{ subtitle }</small>
                                            </>
                                        ) : null
                                    }
                                </h2>
                                
                                {
                                    actions && actions.length > 0 ? (
                                        <ActionButtons
                                            actions={actions}
                                        />
                                    ) : null
                                }
                                
                            </div>

                            <Row>
                                { props.children }
                            </Row>
                        </main>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </React.Fragment>
    );
};

export default Layout;